import React from 'react'
import { isMobile } from 'react-device-detect'
import PropTypes from 'prop-types'

import ThemeTable from '@shared/components/themeTable'

import styles from './styles.module.scss'
import NoData from '@shared/components/noData'
import { getMatchFormat } from '@shared/libs/players'

const PlayerStats = ({ playerStatsData, playerData }) => {
  const batLabels = [
    'Format',
    'Mat',
    'Inns',
    'NO',
    'Runs',
    'HS',
    'Avg',
    'SR',
    '100s',
    '50s',
    '4s',
    '6s',
    'Ct',
    'St'
  ]
  const bowlLabels = [
    'Format',
    'Mat',
    'Inns',
    'Balls',
    'Runs',
    'Wkts',
    'BBI',
    'BBM',
    'Avg',
    'Eco',
    'SR',
    '4w',
    '5w',
    '10w'
  ]

  const labelsMob = ['format', 'test', 't20', 'odi', 't20i']

  return (
    <>
      {
        !playerStatsData && !playerData?.sPlayingRole ? <NoData /> : (
          <>
            {
              playerData?.sPlayingRole !== 'bowl' && playerStatsData?.oBatting && !isMobile && (
                <section className={styles.playerTable}>
                  <h3 className="small-head mt-2">{'Batting & Fielding'}</h3>
                  <ThemeTable labels={batLabels}>
                    {
                      Object.keys(playerStatsData?.oBatting).map((format, index) => {
                        if (format !== '__typename') {
                          return (
                            <tr key={index}>
                              <td>{getMatchFormat(format)}</td>
                              <td>{playerStatsData?.oBatting[format]?.nMatches || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nInnings || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nNotOut || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nRuns || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nHighest || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.sAverage || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.sStrike || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nRun100 || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nRun50 || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nRun4 || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nRun6 || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nCatches || '-'}</td>
                              <td>{playerStatsData?.oBatting[format]?.nStumpings || '-'}</td>
                            </tr>
                          )
                        } else {
                          return null
                        }
                      })
                    }
                  </ThemeTable>
                </section>
              )
            }

            {
              playerData?.sPlayingRole !== 'bat' && playerStatsData?.oBowling && !isMobile && (
                <section className={styles.playerTable}>
                  <h3 className="small-head mt-2">{'Bowling'}</h3>
                  <ThemeTable labels={bowlLabels}>
                    {
                      Object.keys(playerStatsData?.oBowling).map((format, index) => {
                        if (format !== '__typename') {
                          return (
                            <tr key={index}>
                              <td className='text-uppercase'>{getMatchFormat(format)}</td>
                              <td>{playerStatsData?.oBowling[format]?.nMatches || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.nInnings || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.nBalls || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.nRuns || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.nWickets || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.sBestinning || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.sBestmatch || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.sAverage || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.sEcon || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.sStrike || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.nWicket4i || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.nWicket5i || '-'}</td>
                              <td>{playerStatsData?.oBowling[format]?.nWicket10m || '-'}</td>
                            </tr>
                          )
                        } else {
                          return null
                        }
                      })
                    }
                  </ThemeTable>
                </section>
              )
            }

            {
              playerData?.sPlayingRole !== 'bowl' && playerStatsData?.oBatting && isMobile && (
                <section className={styles.playerTable}>
                  <h3 className="small-head mt-2">{'Batting & Fielding'}</h3>
                  <ThemeTable labels={labelsMob}>
                    <tr>
                      <td>Mat</td>
                      <td>{playerStatsData?.oBatting?.test?.nMatches || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nMatches || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nMatches || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nMatches || '-'}</td>
                    </tr>
                    <tr>
                      <td>Inns</td>
                      <td>{playerStatsData?.oBatting?.test?.nInnings || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nInnings || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nInnings || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nInnings || '-'}</td>
                    </tr>
                    <tr>
                      <td>No</td>
                      <td>{playerStatsData?.oBatting?.test?.nNotOut || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nNotOut || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nNotOut || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nNotOut || '-'}</td>
                    </tr>
                    <tr>
                      <td>Runs</td>
                      <td>{playerStatsData?.oBatting?.test?.nRuns || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nRuns || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nRuns || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nRuns || '-'}</td>
                    </tr>
                    <tr>
                      <td>HS</td>
                      <td>{playerStatsData?.oBatting?.test?.nHighest || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nHighest || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nHighest || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nHighest || '-'}</td>
                    </tr>
                    <tr>
                      <td>Avg</td>
                      <td>{playerStatsData?.oBatting?.test?.sAverage || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.sAverage || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.sAverage || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.sAverage || '-'}</td>
                    </tr>
                    <tr>
                      <td>SR</td>
                      <td>{playerStatsData?.oBatting?.test?.sStrike || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.sStrike || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.sStrike || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.sStrike || '-'}</td>
                    </tr>
                    <tr>
                      <td>100s</td>
                      <td>{playerStatsData?.oBatting?.test?.nRun100 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nRun100 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nRun100 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nRun100 || '-'}</td>
                    </tr>
                    <tr>
                      <td>50s</td>
                      <td>{playerStatsData?.oBatting?.test?.nRun50 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nRun50 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nRun50 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nRun50 || '-'}</td>
                    </tr>
                    <tr>
                      <td>4s</td>
                      <td>{playerStatsData?.oBatting?.test?.nRun4 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nRun4 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nRun4 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nRun4 || '-'}</td>
                    </tr>
                    <tr>
                      <td>6s</td>
                      <td>{playerStatsData?.oBatting?.test?.nRun6 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nRun6 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nRun6 || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nRun6 || '-'}</td>
                    </tr>
                    <tr>
                      <td>Ct</td>
                      <td>{playerStatsData?.oBatting?.test?.nCatches || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nCatches || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nCatches || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nCatches || '-'}</td>
                    </tr>
                    <tr>
                      <td>St</td>
                      <td>{playerStatsData?.oBatting?.test?.nStumpings || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20?.nStumpings || '-'}</td>
                      <td>{playerStatsData?.oBatting?.odi?.nStumpings || '-'}</td>
                      <td>{playerStatsData?.oBatting?.t20i?.nStumpings || '-'}</td>
                    </tr>
                  </ThemeTable>
                </section>
              )
            }

            {
              playerData?.sPlayingRole !== 'bbatowl' && playerStatsData?.oBowling && isMobile && (
                <section className={styles.playerTable}>
                  <h3 className="small-head mt-2">{'Bowling'}</h3>
                  <ThemeTable labels={labelsMob}>
                    <tr>
                      <td>Mat</td>
                      <td>{playerStatsData?.oBowling?.test?.nMatches || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.nMatches || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.nMatches || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.nMatches || '-'}</td>
                    </tr>
                    <tr>
                      <td>Inns</td>
                      <td>{playerStatsData?.oBowling?.test?.nInnings || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.nInnings || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.nInnings || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.nInnings || '-'}</td>
                    </tr>
                    <tr>
                      <td>Balls</td>
                      <td>{playerStatsData?.oBowling?.test?.nBalls || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.nBalls || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.nBalls || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.nBalls || '-'}</td>
                    </tr>
                    <tr>
                      <td>Runs</td>
                      <td>{playerStatsData?.oBowling?.test?.nRuns || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.nRuns || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.nRuns || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.nRuns || '-'}</td>
                    </tr>
                    <tr>
                      <td>Wkts</td>
                      <td>{playerStatsData?.oBowling?.test?.nWickets || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.nWickets || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.nWickets || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.nWickets || '-'}</td>
                    </tr>
                    <tr>
                      <td>BBI</td>
                      <td>{playerStatsData?.oBowling?.test?.sBestinning || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.sBestinning || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.sBestinning || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.sBestinning || '-'}</td>
                    </tr>
                    <tr>
                      <td>BBM</td>
                      <td>{playerStatsData?.oBowling?.test?.sBestmatch || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.sBestmatch || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.sBestmatch || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.sBestmatch || '-'}</td>
                    </tr>
                    <tr>
                      <td>Avg</td>
                      <td>{playerStatsData?.oBowling?.test?.sAverage || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.sAverage || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.sAverage || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.sAverage || '-'}</td>
                    </tr>
                    <tr>
                      <td>Eco</td>
                      <td>{playerStatsData?.oBowling?.test?.sEcon || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.sEcon || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.sEcon || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.sEcon || '-'}</td>
                    </tr>
                    <tr>
                      <td>SR</td>
                      <td>{playerStatsData?.oBowling?.test?.sStrike || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.sStrike || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.sStrike || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.sStrike || '-'}</td>
                    </tr>
                    <tr>
                      <td>4w</td>
                      <td>{playerStatsData?.oBowling?.test?.nWicket4i || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.nWicket4i || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.nWicket4i || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.nWicket4i || '-'}</td>
                    </tr>
                    <tr>
                      <td>5w</td>
                      <td>{playerStatsData?.oBowling?.test?.nWicket5i || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.nWicket5i || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.nWicket5i || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.nWicket5i || '-'}</td>
                    </tr>
                    <tr>
                      <td>10w</td>
                      <td>{playerStatsData?.oBowling?.test?.nWicket10m || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20?.nWicket10m || '-'}</td>
                      <td>{playerStatsData?.oBowling?.odi?.nWicket10m || '-'}</td>
                      <td>{playerStatsData?.oBowling?.t20i?.nWicket10m || '-'}</td>
                    </tr>
                  </ThemeTable>
                </section>
              )
            }
          </>
        )
      }
    </>
  )
}

PlayerStats.propTypes = {
  playerStatsData: PropTypes.object,
  playerData: PropTypes.object
}

export default PlayerStats
